import React from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
import { twMerge } from 'tailwind-merge';
import { ImageMedia } from '../imports';
import useWindowSize from '../../hooks/useWindowSize'

// import { useMotionValueEvent } from 'framer-motion';

const MotionContent = ({ children, className, height, imgRef, offsetRange, translateRange, scaleRange, refDiv, clip }) => {

  const { scrollYProgress } = useScroll({
    target: imgRef,
    layoutEffect: false,
    offset: refDiv ?
      ["start start", "end end"] : offsetRange || ['start end ', 'end center']
  });

  // useMotionValueEvent(scrollYProgress, "change", (latest) => { console.log(latest) })

  const translateY = useTransform(scrollYProgress, [0, 1], refDiv ? [0, 0] : translateRange || ["20%", "-10%"])
  const scale = useTransform(scrollYProgress, [0, 1], refDiv ? [1, 1] : scaleRange || [1.3, 1]);
  const clipPath = "polygon(0% 0%, 0% 100%, 100% 100%, 100% 0%)";

  const { onMobile } = useWindowSize();
  const { H, W, screenRatio } = useWindowSize();
  const viewSize = { width: W, height: H }
  const viewScale = .20

  const viewFollow = useTransform(scrollYProgress, [0, 1], [0, (viewSize.height * (viewScale / 1.5))])

  const ContentDiv = !onMobile ? motion.div : "div";
  
  return (
    <ContentDiv style={{ clipPath: clipPath }} className={twMerge(height || "h-[80vh]", className, 'flex center full overflow-visible relative items-start')}>

      <motion.div
        ref={imgRef}
        style={{ translateY, scale, }}
        className='flex center full relative'>

        {children}

      </motion.div>

      {refDiv && !onMobile &&
        <motion.div
          style={{ height: viewSize.height * viewScale, }}
          className='fixed flex center top-16 right-10 z-[10] min-w-16 min-h-16 w-fit overflow-y-clip  m-auto drop-shadow-lg'
        >
          <div className='flex flex-col full relative'>
            <ImageMedia bypass src={refDiv} className="!object-contain full relative =px-1" />
            <motion.div style={{
              aspectRatio: screenRatio,
              translateY: viewFollow
            }}
              className='absolute origin-bottom top-0 inset-0 mx-auto bg-white/20 z-[3]' />
          </div>
        </motion.div>
      }
    </ContentDiv>
  )
}

export default MotionContent